import React, { ReactNode } from 'react';
import { ApolloError } from '@apollo/client';

import { Page } from '@occc-app/design-system';
import { TableContainer, TableHeader, IPaginationProps } from '@occc/ui-design-system';
import { TransactionFragment } from '@occc/graphql';

import { TransactionsTable } from './TransactionsTable';

type TransactionsListPageProps = {
  loading: boolean;
  error?: ApolloError;
  data?: TransactionFragment[];
  paginationProps: IPaginationProps;
  tableHeaderActions: ReactNode;
  shouldShowFraudStatus: boolean;
  onFraudDetailsClick?: (transaction: TransactionFragment) => void;
};

const PAGE_TITLE = 'Transactions';

export const TransactionsListPage: React.FC<TransactionsListPageProps> = ({
  data,
  loading,
  error,
  paginationProps,
  tableHeaderActions,
  shouldShowFraudStatus,
  onFraudDetailsClick,
}) => {
  return (
    <Page browserTabTitle={PAGE_TITLE} pageHeaderProps={{ title: PAGE_TITLE }}>
      <TableContainer>
        <TableHeader title={PAGE_TITLE} actions={tableHeaderActions} />
        <TransactionsTable
          transactions={data}
          loading={loading}
          error={error}
          paginationProps={paginationProps}
          shouldShowFraudStatus={shouldShowFraudStatus}
          onFraudDetailsClick={onFraudDetailsClick}
        />
      </TableContainer>
    </Page>
  );
};
